import ISettings from 'services/configurator/canvas/ISettings';

import { SET_SETTINGS } from './types';

const initialState = {
  settings: null,
};

interface IState {
  settings: ISettings | null;
}

export default (
  state: IState = initialState,
  action: {
    settings?: ISettings | null;
    type: string;
  }
): IState => {
  if (action.type === SET_SETTINGS) {
    if (action.settings === undefined) {
      return state;
    }

    return { ...state, settings: action.settings };
  }

  return state;
};
